export function addCurrent(llmevent) {
  return {
    type: 'ADD_CURRENT',
    llmevent,
  }
}
